module.exports = __webpack_public_path__ + "img/eye-in-welcome.a6efcc91.webp";